import React from 'react';
// @mui
import { TableCell } from '@mui/material';

export default class GridFromToCell extends React.Component {
    render() {
        // props: value, id, field
        const from = this.props.field.fromObj;
        const to = this.props.field.toObj;
        const value = `${this.props.value[from].name} - ${this.props.value[to].name}`;
        return (
            <TableCell
                key={this.props.field.id}
                align="left"
            >
                {value}
            </TableCell>
        );
    }
}
